import { startsWith } from 'ramda';

import { PublicYangoMoviesTrack, PrimaryLanguage } from '../../types';

export const isPrimaryLangTrack = (audioTrack: PublicYangoMoviesTrack): boolean =>
    isPrimaryLang(audioTrack.lang);

export const isPrimaryLang = (lang: string): boolean => startsWith(PrimaryLanguage, lang);
